








import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import loader from "@/components/loader.vue";

@Component({
  components: {
    loader
  }
})
export default class Frame extends Vue {
  @Prop() public value: any;

  private loading = true;
}
